import { DAPI_HOST } from '../../config/index';
import { isServerSide } from '../util/system';
import { apiGetJsonBlocking, apiGetDispatchable } from '../dapi';
import { isEmptyArray } from '../util/array';
import {
  receivePopularCitiesDataSuccess,
  receivePopularCitiesDataError,
} from '../../actions/popularCities';

const getDefaultPopularCitiesPath = () => '/v1/locations/popular-cities?limit=15';

const getNearbyPopularCitiesPath = (lat: any, long: any) =>
  `/v1/locations/popular-cities?latitude=${lat}&longitude=${long}&limit=5`;

export const getPopularCitiesUrl = (lat: any, long: any) =>
  lat && long
    ? `${DAPI_HOST}${getNearbyPopularCitiesPath(lat, long)}`
    : `${DAPI_HOST}${getDefaultPopularCitiesPath()}`;

export const initialFetchPopularCities = async (context: any) => {
  if (isServerSide()) {
    try {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 0.
      const popularCitiesResponse = await apiGetJsonBlocking(getPopularCitiesUrl());
      context.store.dispatch(receivePopularCitiesDataSuccess(popularCitiesResponse.data));
    } catch (e) {
      console.error('Error fetching popular cities: ', e);
      context.store.dispatch(receivePopularCitiesDataError(e));
    }
  } else {
    const { popularCities } = context.store.getState();
    isEmptyArray(popularCities.result) &&
      context.store.dispatch(
        apiGetDispatchable(
          // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 0.
          getPopularCitiesUrl(),
          receivePopularCitiesDataSuccess,
          receivePopularCitiesDataError
        )
      );
  }
};
